import React from "react";
import classes from "./ConfettiCelebration.module.scss";

const CONFETTI_COUNT = 30;

const ConfettiCelebration = ({ active }) => {
  if (!active) return null;

  return (
    <div className={classes.ConfettiContainer}>
      {Array.from({ length: CONFETTI_COUNT }, (_, i) => (
        <div key={i} className={classes.ConfettiPiece} />
      ))}
    </div>
  );
};

export default ConfettiCelebration;
